var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import memoizeOne from 'memoize-one';
import { getUseSharedWorker } from '../worker/canUseSharedWorker';
export const getSocketOrWorker = memoizeOne(() => __awaiter(void 0, void 0, void 0, function* () {
    const useSharedWorker = yield getUseSharedWorker();
    if (useSharedWorker) {
        const { sharedWorkerImplementation } = yield import('./sharedWorkerImplementation');
        return sharedWorkerImplementation;
    }
    const { websocketImplementation } = yield import('./websocketImplementation');
    return websocketImplementation;
}));
